import { deleteAnnouncement, fetchAnnouncement, fetchNotification, postAnnouncemnt, setAnnounceKey, storeAnnouncePage } from 'actions/announcement';
import { Input, Modal, Typography, Select, Button, Checkbox, TimePicker, DatePicker, Alert, Tag, Drawer, Row, Col } from 'antd'
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react'
import ReactQuill from 'react-quill';
import { connect } from 'react-redux';
import styled from 'styled-components'
import 'react-quill/dist/quill.snow.css';
import { CalendarOutlined, DeleteFilled, DeleteOutlined, FieldTimeOutlined, LockFilled, LockOutlined, PercentageOutlined, SearchOutlined, WarningTwoTone } from '@ant-design/icons';
import { notificationBadgeList } from 'actions/login';
import CreateAnnouncmentModal from './createAnnouncmentModal';
import Dragger from 'antd/lib/upload/Dragger';
import { message, Upload } from 'antd';
import file_image_1 from '../../../Assets/images/file_image_1.svg'
import ic_file_eadd from '../../../Assets/images/ic_file_eadd.svg'
import Notification from "services/Notification";
import Xmark from '../../../Assets/common/Xmark.svg'
import AnimatedTextField from 'components/AnimatedTextField';
import downArrow from '../../../Assets/common/downArrow.svg'
import { getAutocompleteSearchForNotification, getCourseDashboardData, getCoursesCategoriesForNotifications, getCoursesSubCategoriesForNotification } from 'actions/courseManagement';
import { fetchClassList } from 'actions/schedule';
import AnimatedDatePicker from 'components/AnimatedDatePicker';
import AnimatedTimePicker from 'components/AnimatedTimePicker';


const { Text } = Typography
const { Option } = Select

const calenderIcon = <CalendarOutlined style={{ color: "#1089FF" }} />
const timeIcon = <FieldTimeOutlined style={{ color: "#1089FF" }} />

const CloneAnnouncement = ({
    isCloneModal, setIsCloneModal, edit, postAnnouncemnt, editData, fetchAnnouncement, togglePageLoader, deleteAnnouncement, fetchNotification, notificationBadgeList, SetKey, standardList,
    sortFilter, searchFilter, announcement, key, setIsModalVisible, setAnnounceKey, storeAnnouncePage, setStdFilterValue, setSort, courseCategoryData, courseSubCategoriesData, autocompleteSearchData, classList,
    fetchClassList, getCoursesCategoriesForNotifications, getCoursesSubCategoriesForNotification, getAutocompleteSearchForNotification,courseDashboardData,getCourseDashboardData
}) => {

    const [check, setCheck] = useState(false)
    const [announceButtonLoader, setAnnounceButtonLoader] = useState(false)
    const [draftButtonLoader, setDraftButtonLoader] = useState(false)
    const [scheduleLoader, setScheduleLoader] = useState(false)
    const [deleteButtonLoader, setDeleteButtonLoader] = useState(false)
    const [id, setId] = useState(null)

    const [title, setTitle] = useState('')
    const [description, setDescription] = useState('')
    const [target, setTarget] = useState('')
    const [date, setDate] = useState(undefined)
    const [time, setTime] = useState(undefined)
    const [type, setType] = useState('')
    const [std, setStd] = useState([])
    const [classListShow, setClassListShow] = useState(true)
    const [className, setClassName] = useState('')
    const [descriptionLength, setDescriptionLength] = useState(null)
    const [file, setfile] = useState([])
    const [hideFile, setHideFile] = useState(true)
    const [fileVisible, setFileVisible] = useState(editData?.fileName)
    const [isDisable, setIsDisable] = useState(false)
    const [isFileSize, setIsFileSize] = useState(10 * 1024 * 1024)
    const [deleteShow, setDeleteShow] = useState(false)
    const [studentsType, setStudentsType] = useState('allStudents')
    const [checkedItems, setCheckedItems] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState([]);
    const [selectedSubCategory, setSelectedSubCategory] = useState([]);
    const [selectedCourses, setSelectedCourses] = useState([]);
    const [selectedBatches, setSelectedBatches] = useState([]);
    const [updatedClassList, setUpdatedClassList] = useState([]);
    const [momentDate, setMomentDate] = useState(edit !== '' ? true : false);

    useEffect(() => {
        getCoursesCategoriesForNotifications()
        getCoursesSubCategoriesForNotification()
        getAutocompleteSearchForNotification(null, () => { })
        fetchClassList('', null)
        getCourseDashboardData(()=>{})
    }, [])

    useEffect(() => {
        setUpdatedClassList(classList.map(({ section,std, ...rest }) => ({
            ...rest,
            name:  `${std} - ${section}` // Rename 'section' to 'name'
        })))
    }, [])

    const options = [
        courseDashboardData?.overview?.some(item => item?.overviewType == "liveCourse") && { label: "Live courses", value: "course" },
        courseDashboardData?.overview?.some(item => item?.overviewType == "videoResource") && { label: "Video resources", value: "videoResource" },
        courseDashboardData?.overview?.some(item => item?.overviewType == "testSeries") && { label: "Online test series", value: "testSeries" },
        courseDashboardData?.overview?.some(item => item?.overviewType == "studyMaterial") &&  { label: "Study materials", value: "studyMaterial" },
        
    ].filter(Boolean);

    const handleChange = (checkedValues) => {
        setCheckedItems(checkedValues);
    };

    const handleChangeCategories = (value) => {
        const selectedCourse = courseCategoryData.find(course => course.id === value);
        if (selectedCourse) {
            const isAlreadySelected = selectedCategory.some(course => course.id === value);
            if (!isAlreadySelected) {
                setSelectedCategory(prevCourses => [...prevCourses, selectedCourse]);
            }
        }
    };
    const handleChangeSubCategories = (value) => {
        const selectedCourse = courseSubCategoriesData.find(course => course.id === value);
        if (selectedCourse) {
            const isAlreadySelected = selectedSubCategory.some(course => course.id === value);
            if (!isAlreadySelected) {
                setSelectedSubCategory(prevCourses => [...prevCourses, selectedCourse]);
            }
        }
    };
    const handleChangeCourses = (value) => {
        const selectedCourse = autocompleteSearchData.find(course => course.id === value);
        if (selectedCourse) {
            const isAlreadySelected = selectedCourses.some(course => course.id === value);
            if (!isAlreadySelected) {
                setSelectedCourses(prevCourses => [...prevCourses, selectedCourse]);
            }
        }
    };

    const handleChangeBatches = (value) => {
        const selectedCourse = updatedClassList.find(course => course.id === value);
        if (selectedCourse) {
            const isAlreadySelected = selectedBatches.some(course => course.id === value);
            if (!isAlreadySelected) {
                setSelectedBatches(prevCourses => [...prevCourses, selectedCourse]);
            }
        }
    };

    const handleRemoveCategory = (courseId) => {
        setSelectedCategory(selectedCategory.filter(course => course.id !== courseId));
    };

    const handleRemoveSubCategory = (courseId) => {
        setSelectedSubCategory(selectedSubCategory.filter(course => course.id !== courseId));
    };

    const handleRemoveCourses = (courseId) => {
        setSelectedCourses(selectedCourses.filter(course => course.id !== courseId));
    };
    const handleRemoveBatches = (courseId) => {
        setSelectedBatches(selectedBatches.filter(course => course.id !== courseId));
    };



    useEffect(() => {
        // setIsModalVisible(false)

        // if (edit == 'clone' && Object.keys(editData)?.length != 0) {
        setTitle(editData?.title)
        setDescription(editData?.description)
        setTarget(editData?.target ? editData?.target : 'All')
        
  
        // setDate(moment(editData?.date, 'YYYY-MM-DD').format('YYYY-MM-DD'))
        // setTime(moment(time, 'HH:mm').format('HH:mm'))
        setId(editData?.id)
        setCheck(false)
        setDate(undefined)
        setTime(undefined)

        if (editData?.target == 'Student') {
            if (editData?.subtarget == 'standard') {
                let standardIds = editData?.standardAnnouncement?.map(item => item?.standardId)

                setStudentsType('batch')
                setSelectedBatches(classList.map(({ section, std, ...rest }) => ({
                    ...rest,
                    name: `${std} - ${section}` // Rename 'section' to 'name'
                })).filter(item => standardIds.includes(item.id)))
            }

            if (editData?.subtarget == 'courses') {
                setStudentsType('course')
                const matchedCourses = editData?.courseItems
                    ?.map(item => autocompleteSearchData.find(data =>
                        data.itemId === item.courseId && data.itemType === item.courseType
                    ))
                    .filter(Boolean);
                setSelectedCourses(matchedCourses)
            }

            if (editData?.subtarget == 'category') {
                setStudentsType('courseCategory')
                const matchedCourses = editData.categories
                    .map(item => courseCategoryData.find(data =>
                        data.id === item.id
                    ))
                    .filter(Boolean);
                setSelectedCategory(matchedCourses)
            }

            if (editData?.subtarget == 'subcategory') {
                setStudentsType('courseSubcategory')
                const matchedCourses = editData.subcategories
                    .map(item => courseSubCategoriesData.find(data =>
                        data.id === item.id
                    ))
                    .filter(Boolean);
                setSelectedSubCategory(matchedCourses)
            }

            if (editData?.subtarget == 'courseType') {
                setStudentsType('courseType')
                let courseTypes = []
                if (editData?.applicableLive) courseTypes.push("course");
                if (editData?.applicableTest) courseTypes.push("testSeries");
                if (editData?.applicableStudy) courseTypes.push("studyMaterial");
                if (editData?.applicableVideo) courseTypes.push("videoResource");
                setCheckedItems(courseTypes)
            }
        }

        // if (editData?.target == 'Student' && editData?.standardStatus == 0) {
        //     if (editData?.standardAnnouncement?.length != 0) {
        //         let temp = []
        //         editData?.standardAnnouncement?.map((item) => (
        //             temp?.push(item?.standardId)
        //         ))
             
        //         setStd(temp)
        //         setClassListShow(true)
        //     }
        // }
        // else if (editData?.target == 'Student' && editData?.standardStatus == -1) {
        //     setStd([-1])
        //     setClassListShow(false)
        // }
        // }
    }, [JSON.stringify(editData)])

    useEffect(() => {

        if (std[0] != undefined || std[0] != -1) {

            if (std?.length == standardList.length) {
                setClassListShow(false)
                setStd([-1])
            }
        }

    }, [std?.length])

    useEffect(() => {
        setCheck(false)
        setDate(undefined)
        setTime(undefined)
    }, [])
    let quillReff = null
    var details = {}
    function handleRemove(info) {
        let temp = []
        for (let i = 0; i < file.length; i++) {
            if (file[i].uid !== info) {
                temp.push(file[i])
            }
        }
        setfile([...temp]);
        if (hideFile) {
            setFileVisible('old file')
        } else {
            setFileVisible(null);
        }
        // setFileVisible(null)

    }
    const fileSizeLimit = 10 * 1024 * 1024

    const props = {
        name: 'file',
        multiple: true,
        customRequest({ onSuccess }) {
            setTimeout(() => onSuccess('ok'), 0);
        },
        onChange(info) {
            const { status } = info.file;
            if (info.file.status === 'uploading') {
                return

            }
            if (info.file.status === "done" || info.file.status === "error") {
                const fileExtension = info.file.name ? info.file.name.split('.').pop().toLowerCase() : '';
                const isImage = ['png', 'jpg', 'jpeg'].includes(fileExtension);
                const currentLimit = isImage ? 5 * 1024 * 1024 : 10 * 1024 * 1024;
                getBase64(info.file.originFileObj, (imageUrl) => {
                    if (info.file.size > currentLimit) {
                        // setIsFileSize([...file, info.file.originFileObj])
                        Notification.error('Error', isImage ? 'Image size exceeds the limit of 5MB.' : 'File size exceeds the limit of 10MB.');
                        if (hideFile) {
                            setFileVisible('new file and old file')
                        }
                    }
                    else {
                        setfile([...file, info.file.originFileObj])
                        if (hideFile) {
                            setFileVisible('new file and old file')
                        } else {
                            setFileVisible('old file')
                        }

                    }
                    // setFileVisible('file is there')
                    // toggleImageLoader(false);
                });



            }
        },
        onDrop(e) {
        },
        beforeUpload(file) {
            const allowedExtensions = ['doc', 'docx', 'xls', 'xlsx', 'pdf', 'png', 'jpg', 'jpeg'];
            const fileExtension = file.name.split('.').pop().toLowerCase();
            if (!allowedExtensions.includes(fileExtension)) {
                Notification.error('Error', 'Only doc, xlsx, pdf, png, jpg files are supported!');
                return Upload.LIST_IGNORE;
            }
            const isImage = ['png', 'jpg', 'jpeg'].includes(fileExtension);
            if (isImage && file.size > 5 * 1024 * 1024) {
                Notification.error('Error', 'Image size exceeds the limit of 5MB.');
                return Upload.LIST_IGNORE;
            }
            if (!isImage && file.size > 10 * 1024 * 1024) {
                Notification.error('Error', 'File size exceeds the limit of 10MB.');
                return Upload.LIST_IGNORE;
            }
            return true;
        },
        onRemove(info, index) {
            handleRemove(info.uid);
        }
    };
    const getBase64 = (img, callback) => {
        const reader = new FileReader();
        reader.addEventListener("load", () => callback(reader.result));
        reader.readAsDataURL(img);
    };

    const modules = {
        toolbar: [
            [{ 'header': [1, 2, false] }],
            ['bold', 'italic', 'underline'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['link'],
        ],
    }

    const handleCancle = () => {
        // setIsModalVisible(false)
        setTitle(editData?.title)
        setDescription(editData?.description)
        setTarget(editData?.target)
        setDate('')
        setTime('')
        setId(editData?.id)
        setCheck(false)
        // setfile(editData?.fileName[0]?.key)
        if (editData?.target == 'Student' && editData?.standardStatus == 0) {
            if (editData?.standardAnnouncement?.length != 0) {
                let temp = []
                editData?.standardAnnouncement?.map((item) => (
                    temp?.push(item?.standardId)
                ))
             
                setStd(temp)
                setClassListShow(true)
            }
        }
        else if (editData?.target == 'Student' && editData?.standardStatus == -1) {
            setStd([-1])
            setClassListShow(false)
        }
        setIsCloneModal(false)
    }
    const handleChangeTarget = (value) => {
        if (value) {
            setTarget(value)
        }
        else {
            setTarget(null)
        }
        setStd([])
        setStudentsType('allStudents')
        setSelectedBatches([])
        setSelectedCourses([])
        setSelectedCategory([])
        setSelectedSubCategory([])
        setCheckedItems([])
    }

    const onChangeCheckBox = (e) => {
        const isChecked = e.target.checked;
        if (!isChecked) {
            setDate(undefined); // Clear the date
            setTime(undefined)
        }
        setCheck(isChecked);
    };

    const handleTitle = (e) => {
        e.preventDefault()
        setTitle(e.target.value)
    }

    const handleDescription = (content, delta, source, editor) => {
        // source == user means while creating or change by user
        if (source == 'user') {
            details = {
                mobile: quillReff.getEditorContents(),
                web: quillReff.editor.getContents()
            }
            setDescription(JSON.stringify(details))
        }
    }

    const handleDescriptionKeyPress = (event) => {
        if (quillReff.getEditorContents() != '<p><br></p>' && quillReff.editor.getText().trim() != '') {
            setDescriptionLength(quillReff.editor.getLength())
            details = {
                mobile: quillReff.getEditorContents(),
                web: quillReff.editor.getContents()
            }
            setDescription(JSON.stringify(details))

        }
        else {
            setDescription('')
        }
    }
    const handleDescriptionkeyUp = (e) => {
        if (quillReff.getEditorContents() != '<p><br></p>' && quillReff.editor.getText().trim() != '') {

            setDescriptionLength(quillReff.editor.getLength())
            details = {
                mobile: quillReff.getEditorContents(),
                web: quillReff.editor.getContents()
            }
            setDescription(JSON.stringify(details))

        }
        else {
            setDescription('')
        }
    }



    const handleButton = (type) => {
        // setIsModalVisible(false)

        setType(type)
        let object = {}
        if (edit == 'announce') {

            if (title && target && type && description !== null) {

                object = {
                    cloneId: id,
                    title: title,
                    description: description,
                    target: target,
                    standardIds: std,
                    type: type,
                    date: date ? date : null,
                    time: time != 'Invalid date' ? time : null,
                    typeAnnouncement: "text",

                }

            } else {
                object = {
                    cloneId: id,
                    title: title,
                    // description: description,
                    target: target,
                    standardIds: std,
                    type: type,
                    date: date ? date : null,
                    time: time ? time : null,

                    typeAnnouncement: "file",
                    files: [...file],

                }
            }
        }
        if (edit == 'clone') {
           

            if (title && target && type && description !== null) {

                object = {
                    cloneId: id,
                    title: title,
                    description: description,
                    target: target,
                    standardIds: std,
                    type: type,
                    date: date ? date : null,
                    time: time ? time : null,
                    typeAnnouncement: "text",

                }

            } else {
                object = {
                    cloneId: id,
                    title: title,
                    // description: description,
                    target: target,
                    standardIds: std,
                    type: type,
                    date: date ? date : null,
                    time: time ? time : null,

                    typeAnnouncement: "file",
                    files: [...file],

                }
            }
        }
        if (edit == 'schedule') {
         
            if (title && target && type && description !== null) {

                object = {
                    cloneId: id,
                    title: title,
                    description: description,
                    target: target,
                    standardIds: std,
                    type: type,
                    date: date ? date : null,
                    time: time ? time : null,
                    typeAnnouncement: "text",

                }

            } else {
                object = {
                    cloneId: id,
                    title: title,
                    // description: description,
                    target: target,
                    standardIds: std,
                    type: type,
                    date: date ? date : null,
                    time: time ? time : null,
                    typeAnnouncement: "file",
                    files: [...file],

                }
            }
        }
        if (object.date && moment(object.date, 'DD/MM/YYYY', true).isValid()) {
            object.date = moment(object.date, 'DD/MM/YYYY').format('YYYY-MM-DD');
        }

        object.courseItems = studentsType == 'course' ? selectedCourses?.map(item => ({
            id: item.itemId,
            resourceType: item.itemType
        })) : [];

        object.standardIds = studentsType == 'batch' ? selectedBatches?.map(item => item.id) : [];
        object.categoryIds = studentsType == 'courseCategory' ? selectedCategory?.map(item => item.id) : [];
        object.subcategoryIds = studentsType == 'courseSubcategory' ? selectedSubCategory?.map(item => item.id) : [];
        object.courseTypes = studentsType == 'courseType' ? checkedItems : [];
        object.subtarget = target == 'Student' ? studentsType == 'course' ? 'courses' : studentsType == 'batch' ? 'standard' : studentsType == 'courseCategory' ? 'category' :
            studentsType == 'courseSubcategory' ? 'subcategory' : studentsType == 'courseType' ? 'courseType' : null : undefined


        if (type == 'ANNOUNCENOW') {
            setAnnounceButtonLoader(true)
            // SetKey('3')
            postAnnouncemnt(object, () => { setAnnounceButtonLoader(false) },
                () => {
                    setAnnounceKey('3')
                    setIsModalVisible(false)
                    setAnnounceButtonLoader(false)
                    setDraftButtonLoader(false)
                    setScheduleLoader(false)
                    setDeleteButtonLoader(false)
                    // setDescriptionLength(null)
                    setTitle('')
                    // setDescription('')
                    setTarget('')
                    setDate('')
                    setTime('')
                    setStd([])
                    setCheck(false)
                    setIsCloneModal(false)
                    // notificationBadgeList()
                    togglePageLoader(true)
                    fetchAnnouncement('', '', () => togglePageLoader(false))
                    setSort([]);
                    setStdFilterValue([])
                })
        }
        if (type == 'DRAFT') {
     
            setDraftButtonLoader(true)
            // SetKey('1')
            postAnnouncemnt(object, () => { setDraftButtonLoader(false) },
                () => {
                    setAnnounceKey('1')

                    setIsModalVisible(false)
                    setAnnounceButtonLoader(false)
                    setDraftButtonLoader(false)
                    setScheduleLoader(false)
                    setDeleteButtonLoader(false)
                    // setDescriptionLength(null)
                    setTitle('')
                    // setDescription('')
                    setTarget('')
                    setDate('')
                    setTime('')
                    setStd([])
                    setCheck(false)
                    setIsCloneModal(false)
                    // notificationBadgeList()
                    togglePageLoader(true)
                    fetchAnnouncement('', '', () => togglePageLoader(false))
                    setSort([]);
                    setStdFilterValue([])
                }
            )
        }
        if (type == 'SCHEDULE') {
            setScheduleLoader(true)
            postAnnouncemnt(object, () => { setScheduleLoader(false) },
                () => {
                    setAnnounceKey('2')

                    setIsModalVisible(false)
                    setAnnounceButtonLoader(false)
                    setDraftButtonLoader(false)
                    setScheduleLoader(false)
                    setDeleteButtonLoader(false)
                    // setDescriptionLength(null)
                    setTitle('')
                    // setDescription('')
                    setTarget('')
                    setDate('')
                    setTime('')
                    setStd([])
                    setCheck(false)
                    setIsCloneModal(false)
                    // notificationBadgeList()
                    togglePageLoader(true)
                    fetchAnnouncement('', '', () => togglePageLoader(false))

                })
        }


    }

    const handleClass = (e, obj) => {
        if (e.includes(-1)) {
            setClassListShow(false)
            setStd([-1])
        }
        else if (!e.length == 0) {
            setStd(e)
        }
        else {
            setStd(e)
            setClassListShow(true)
        }
    }

    const onSelect = (value, obj) => {
        if (value == -1) {
            setStd([-1])
        }
    }
    const handleDate = (date, dateString) => {
        setMomentDate(false)
        setDate(dateString)
        setIsDisable(true)
    }
    const handleTime = (time, timeString) => {
        setTime(moment(timeString, "hh:mm A").format("HH:mm"));
    }
    // const handleDelete = () => {

    //     console.log("AA-id1",id);
    //     setDeleteButtonLoader(true)
    //     deleteAnnouncement(id, () => setDeleteButtonLoader(false), successCallback)
    // }

    const handleRemoveValue = () => {
        if (file.length != 0) {
            setFileVisible('new file')
        } else {
            setFileVisible(null);
        }
        // setFileVisible(null)
        setHideFile(false)
    }

    const disabledDate = (current) => {
        // Can not select days before today and today
        return current && current < moment().startOf('day');

    }
    const disabledStartTimeHours = () => {
        const hours = [];
        if (date && moment(date, ['DD/MM/YYYY', 'YYYY-MM-DD']).isSame(moment(), 'day')) {
            const minAllowedTime = moment().add(10, 'minutes');
            for (var i = 0; i < minAllowedTime.hour(); i++) {
                hours.push(i);
            }
        }
        return hours;
    };

    const disabledStartTimeMinutes = (selectedHour) => {
        var minutes = [];
        if (date && moment(date, ['DD/MM/YYYY', 'YYYY-MM-DD']).isSame(moment(), 'day')) {
            const minAllowedTime = moment().add(10, 'minutes');
            if (selectedHour === minAllowedTime.hour()) {
                for (var i = 0; i < minAllowedTime.minute(); i++) {
                    minutes.push(i);
                }
            } else if (selectedHour < minAllowedTime.hour()) {
                for (var i = 0; i < 60; i++) {
                    minutes.push(i);
                }
            }
        }
        return minutes;
    }

    const isDisabled = target == 'Student' && !(
        studentsType === 'allStudents' ||
        (studentsType === 'course' && selectedCourses.length > 0) ||
        (studentsType === 'batch' && selectedBatches.length > 0) ||
        (studentsType === 'courseType' && checkedItems.length > 0) ||
        (studentsType === 'courseCategory' && selectedCategory.length > 0) ||
        (studentsType === 'courseSubcategory' && selectedSubCategory.length > 0)
    );
    console.log('isDisabled', isDisabled,
        (((title && title.trim() != '') && description != '' && descriptionLength <= 250 && !isDisabled) || ((title && title.trim() != '') && description != '' && target && descriptionLength <= 250 && !isDisabled) ? announceButtonLoader ? true : false : true));


 
    return (
        <div>
            <Drawer
                // className="createFormAnnouncement"
                visible={isCloneModal}
                //centered={true}
                width={"500px"}
                closable={false}
                onClose={() => handleCancle()}
            >

                <div className='scroll-bar-universal' style={{ height: '90%', }}>
                    <div style={{ padding: '0px 20px', display: 'flex', justifyContent: 'space-between', marginTop: 10 }}>
                        <div style={{ fontWeight: 'bold', fontSize: '20px', color: '#191919', fontFamily: 'Roboto, sans-serif' }}>{'Clone Announcement'} </div>
                        <div onClick={() => handleCancle()}><img style={{ height: 16, width: 16, cursor: 'pointer' }} src={Xmark} /></div>
                    </div>

                    <div style={{ padding: '0px 20px' }}>
                        <AnimatedTextField
                            label="Title"
                            isMandatory={true}
                            inputId="title-name"
                            value={title ? title : ''}
                            handleInputChange={(e) => handleTitle(e)}
                        />
                    </div>
                    {
                        editData?.typeAnnouncement === 'file' ?
                            <>
                                <div style={{ marginTop: "20px",padding:'5px 20px' }}>
                                    <div style={{ fontFamily: 'roboto', color: '#AEAEAE' }}>Attachments<span style={{ color: '#ff414d' }}>*</span></div>
                                    <Dragger {...props}
                                        maxCount={1}
                                        disabled={file.length > 0 || (editData?.typeAnnouncement === 'file' && hideFile)}
                                        className={(file.length > 0 || (editData?.typeAnnouncement === 'file' && hideFile)) ? "disabled-drag-box" : ""}
                                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.xsl,.pdf,.doc,.docx,.jpg,.jpeg,.png" listType="picture" progress={PercentageOutlined} style={{ borderColor: "#1089FF" }}>
                                        <div className="ant-upload-drag-icon">
                                            <img src={ic_file_eadd} />
                                        </div>
                                        <div style={{ display: "flex", justifyContent: "center" }}>
                                            <div className="ant-upload-text" style={{ color: "#AEAEAE", fontSize: "13px", fontWeight: "bold" }}>Drop file here or</div>
                                            <div className="ant-upload-hint" style={{ color: "#1089FF", fontSize: "13px", fontWeight: "bold", marginLeft: "5px" }}>
                                                Click to Upload
                                            </div>
                                        </div>
                                        <div style={{ color: '#AEAEAE', fontSize: '11px', marginTop: '6px' }}>
                                            Only (doc, xlsx, pdf, png, jpg, etc.) supported
                                        </div>
                                    </Dragger>
                                </div>
                                {fileVisible == "new file and old file" ? Notification.error("Error", 'Multiple files are not allowed') : null}

                                {hideFile ? <div style={{ marginTop: '10px', padding:'5px 20px'}}>
                                    <div className='shadow-box hover-shadow customCardShadow' style={{ height: "60px", display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 15px", width:'100%' }}>
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            <img src={file_image_1} style={{ width: "22px", height: "22px", marginRight: "15px" }} />
                                            <div style={{ fontSize: "13px", fontWeight: "bold", color: "#191919" }}>{editData?.fileName[0]?.key}</div>
                                        </div>
                                        <div style={{ cursor: "pointer" }} onClick={() => { handleRemoveValue() }}>
                                            <DeleteOutlined style={{ fontSize: "20px", color: "#FF414D" }} />
                                        </div>

                                    </div>
                                </div> : null}
                            </> :


                            <div className='descriptionClass test-texteditor-wrapper' style={{ padding: '10px' }}>
                                <div style={{ display: 'flex' }}>
                                    <div style={{ fontFamily: 'roboto', color: '#AEAEAE' }}>Description</div><span style={{ color: '#ff414d' }}>*</span>
                                </div>
                                <ReactQuill
                                    className='annocnementDescription link-div'
                                    theme='snow'
                                    style={{ height: '100%' }}
                                    modules={modules}
                                    value={description && Object.keys(description).length != 0 ? JSON.parse(description).mobile : ''}
                                    onChange={(content, delta, source, editor) => handleDescription(content, delta, source, editor)}
                                    ref={el => quillReff = el}
                                    placeholder="Enter Description"
                                    bounds={'.annocnementDescription'}
                                    //  onBlur={() => handleBlur()}
                                    // onKeyPress={(e) => handleDescriptionKeyPress(e)}
                                    onKeyUp={(e) => handleDescriptionkeyUp(e)}

                                />
                                {descriptionLength != null && descriptionLength > 250 ?
                                    <div>
                                        <WarningTwoTone twoToneColor='#FF0000' /> <Text style={{ color: 'red' }}>Description should be less than 250 character</Text>
                                    </div>
                                    : null}
                            </div>
                    }








                    <div style={{ display: 'flex', width: '100%', marginTop: 20, padding: '0px 20px', }}>

                        <div style={{ width: '50%' }}>
                            <div style={{ color: '#aeaeae', fontSize: 14, }}>Target <span style={{ color: '#ff414d' }}>*</span></div>
                            <div style={{ marginLeft: -8, marginTop: -5, }}>
                                <Select
                                    bordered={null}
                                    getPopupContainer={(trigger) => trigger.parentElement}
                                    value={target ? target : null}
                                    onChange={handleChangeTarget}
                                    style={{ width: '98%' }}
                                    suffixIcon={<img src={downArrow} alt="custom icon" style={{ width: 16, height: 16 }} />}
                                >
                                    <Option value={'All'}>All</Option>
                                    <Option value={'Teacher'}>Teacher</Option>
                                    <Option value={'Student'}>Student</Option>
                                    <Option value={'Data Operator'}>Data Operator</Option>
                                    <Option value={'Operation'}>Operations</Option>
                                </Select>
                            </div>
                            <div style={{ borderBottom: '1px solid #d7d7d7', marginLeft: 5, width: '92%', }}></div>
                        </div>
                        {target == 'Student' ?
                            <div style={{ width: '50%', marginLeft: '6%' }}>
                                <div style={{ color: '#aeaeae', fontSize: 14, }}>Select a student group <span style={{ color: '#ff414d' }}>*</span></div>
                                <div style={{ marginLeft: -10, marginTop: -5 }}>
                                    <Select
                                        bordered={null}
                                        // placeholder="Select plan"
                                        getPopupContainer={(trigger) => trigger.parentElement}
                                        value={studentsType}
                                        onChange={(e) => {
                                            setStudentsType(e)
                                        }}
                                        style={{ width: '98%' }}
                                        suffixIcon={<img src={downArrow} alt="custom icon1" style={{ width: 16, height: 16 }} />}
                                    >
                                        <Option value="allStudents">All students</Option>
                                        <Option value="batch">Batch</Option>
                                        <Option value="course">Course</Option>
                                        <Option value="courseType">Course type</Option>
                                        <Option value="courseCategory">Course category</Option>
                                        <Option value="courseSubcategory">Course subcategory</Option>
                                    </Select>
                                </div>
                                <div style={{ borderBottom: '1px solid #d7d7d7', marginLeft: 2, width: '92%', }}></div>
                            </div>
                            : null}
                    </div>


                    {/* <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div style={{ width: '50%', padding: '10px', display: 'flex', flexDirection: 'column' }}>
                        <Text style={{ fontFamily: 'roboto', fontWeight: 'bold' }}>Target</Text>
                        <Select
                            getPopupContainer={(trigger) => trigger.parentElement}
                            value={target}
                            onChange={handleChangeTarget}
                            size='middle'
                            placeholder={'Select Target'}
                        >
                            <Option value={'All'}>All</Option>
                            <Option value={'Teacher'}>Teacher</Option>
                            <Option value={'Student'}>Student</Option>
                            <Option value={'Data Operator'}>Data Operator</Option>
                            <Option value={'Operation'}>Operations</Option>
                        </Select>
                    </div>
                    {target == 'Student' ?
                        <div id='select' style={{ width: '50%', padding: '10px', display: 'flex', flexDirection: 'column' }}>
                            <Text style={{ fontFamily: 'roboto', fontWeight: 'bold' }}>Class(es)</Text>
                            {console.log("AA-studentClass", std)}
                            <Select
                                getPopupContainer={(trigger) => trigger.parentElement}
                                placeholder='Select Class'
                                mode='multiple'
                                // tagRender={tagRender}
                                filterOption={true}
                                optionFilterProp='children'
                                onChange={handleClass}
                                onSelect={onSelect}
                                value={std}

                            >
                                <Option value={-1}>All</Option>
                                {classListShow && standardList.length != 0 ? standardList.map((item) => (
                                    <Option value={item.id}>{item.std + "-" + item.section}</Option>
                                )) : null}
                            </Select>
                        </div>
                        : null}
                </div> */}

                    {
                        target == 'Student' && studentsType == 'courseType' ?
                            <div style={{ marginLeft: 25, marginTop: 20, width: '90%' }}>
                                <Checkbox.Group value={checkedItems} onChange={handleChange}>
                                    <Row gutter={[20, 10]} style={{ fontFamily: "Roboto, sans-serif" }}>
                                        {options.map((option) => (
                                            <Col key={option.value} xs={24} sm={12} md={12}> {/* 2 items per row */}
                                                <Checkbox
                                                    value={option.value}
                                                    style={{
                                                        color: "#636363",
                                                        fontSize: 16,
                                                        width:200
                                                    }}
                                                >
                                                    {option.label}
                                                </Checkbox>
                                            </Col>
                                        ))}
                                    </Row>
                                </Checkbox.Group>
                            </div>
                            :
                            target == 'Student' && studentsType == 'courseCategory'
                                ?
                                <div style={{ marginTop: 20 }}>
                                    <div style={{ color: '#aeaeae', fontSize: 14, padding: '0px 20px' }}>Select course categories <span style={{ color: '#ff414d' }}>*</span></div>
                                    <div style={{ marginLeft: 8, marginTop: -5 }}>
                                        <Select
                                            bordered={null}
                                            showSearch={true}
                                            placeholder={
                                                <span style={{marginLeft:-10, position:'absolute', zIndex:1}}>
                                                    <SearchOutlined style={{ marginRight: 8, color: "#aeaeae" }} />
                                                    Sample: Marketing, Cloud computing etc.
                                                </span>
                                            }

                                            onChange={(value) => {
                                                handleChangeCategories(value);
                                            }}
                                            style={{ width: '98%' }}
                                            suffixIcon={<img src={downArrow} alt="custom icon" style={{ width: 16, height: 16 }} />}
                                            value={null}
                                            filterOption={(input, option) => {
                                                // Case-insensitive search
                                                return option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                            }}
                                            // Optional: customize the no-match message
                                            notFoundContent="No matching category found"
                                        >
                                            {courseCategoryData.map((course) => {
                                                const isSelected = selectedCategory.some(selected => selected.id === course.id);
                                                return (
                                                    <Option
                                                        key={course.id}
                                                        value={course.id}
                                                        style={{
                                                            backgroundColor: isSelected ? '#dacff2' : 'transparent',
                                                            fontWeight: isSelected ? '500' : 'normal',
                                                            borderRadius: 5,
                                                            marginBottom: 2
                                                        }}
                                                    >
                                                        {course.name}
                                                    </Option>
                                                );
                                            })}
                                        </Select>
                                    </div>
                                    <div style={{ borderBottom: '1px solid #d7d7d7', marginLeft: 18, width: '92%', }}></div>
                                    <div className="selected-courses">
                                        {selectedCategory.map((course) => (
                                            <div key={course.id} className="course-tag">
                                                {course.name}
                                                <span
                                                    className="remove-icon"
                                                    onClick={() => handleRemoveCategory(course.id)}
                                                >
                                                    <img style={{ width: 12, height: 12, marginTop: -6 }} src={Xmark} />
                                                </span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                :
                                target == 'Student' && studentsType == 'courseSubcategory'
                                    ?
                                    <div style={{ marginTop: 20 }}>
                                        <div style={{ color: '#aeaeae', fontSize: 14, padding: '0px 20px' }}>Select course subcategory <span style={{ color: '#ff414d' }}>*</span></div>
                                        <div style={{ marginLeft: 8, marginTop: -5 }}>
                                            <Select
                                                bordered={null}
                                                showSearch={true}
                                                placeholder={
                                                    <span style={{marginLeft:-10, position:'absolute', zIndex:1}}>
                                                        <SearchOutlined style={{ marginRight: 8, color: "#aeaeae" }} />
                                                        Sample: Marketing, Cloud computing etc.
                                                    </span>
                                                }

                                                onChange={(value) => {
                                                    
                                                    handleChangeSubCategories(value);
                                                }}
                                                style={{ width: '98%' }}
                                                suffixIcon={<img src={downArrow} alt="custom icon" style={{ width: 16, height: 16 }} />}
                                                value={null}
                                                filterOption={(input, option) => {
                                                    // Case-insensitive search
                                                    return option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                                }}
                                                // Optional: customize the no-match message
                                                notFoundContent="No matching subcategoryy found"
                                            >
                                                {courseSubCategoriesData.map((course) => {
                                                    const isSelected = selectedSubCategory.some(selected => selected.id === course.id);
                                                    return (
                                                        <Option
                                                            key={course.id}
                                                            value={course.id}
                                                            style={{
                                                                backgroundColor: isSelected ? '#dacff2' : 'transparent',
                                                                fontWeight: isSelected ? '500' : 'normal',
                                                                borderRadius: 5,
                                                                marginBottom: 2
                                                            }}
                                                        >
                                                            {course.name}
                                                        </Option>
                                                    );
                                                })}
                                            </Select>
                                        </div>
                                        <div style={{ borderBottom: '1px solid #d7d7d7', marginLeft: 18, width: '92%', }}></div>
                                        <div className="selected-courses">
                                            {selectedSubCategory.map((course) => (
                                                <div key={course.id} className="course-tag">
                                                    {course.name}
                                                    <span
                                                        className="remove-icon"
                                                        onClick={() => handleRemoveSubCategory(course.id)}
                                                    >
                                                        <img style={{ width: 12, height: 12, marginTop: -6 }} src={Xmark} />
                                                    </span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    :

                                    target == 'Student' && studentsType == 'course'
                                        ?
                                        <div style={{ marginTop: 20 }}>
                                            <div style={{ color: '#aeaeae', fontSize: 14, padding: '0px 20px' }}>Select course name <span style={{ color: '#ff414d' }}>*</span></div>
                                            <div style={{ marginLeft: 8, marginTop: -5 }}>
                                                <Select
                                                    bordered={null}
                                                    showSearch={true}
                                                    placeholder={
                                                        <span style={{marginLeft:-10, position:'absolute', zIndex:1}}>
                                                            <SearchOutlined style={{ marginRight: 8, color: "#aeaeae" }} />
                                                            Sample: JEE main 2025 etc.
                                                        </span>
                                                    }

                                                    onChange={(value) => {
                                                        handleChangeCourses(value);
                                                    }}
                                                    style={{ width: '98%' }}
                                                    suffixIcon={<img src={downArrow} alt="custom icon" style={{ width: 16, height: 16 }} />}
                                                    value={null}
                                                    filterOption={(input, option) => {
                                                        // Case-insensitive search
                                                        return option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                                    }}
                                                    // Optional: customize the no-match message
                                                    notFoundContent="No matching course found"
                                                >
                                                    {autocompleteSearchData.map((course) => {
                                                        const isSelected = selectedCourses.some(selected => selected.id === course.id);
                                                        return (
                                                            <Option
                                                                key={course.id}
                                                                value={course.id}
                                                                style={{
                                                                    backgroundColor: isSelected ? '#dacff2' : 'transparent',
                                                                    fontWeight: isSelected ? '500' : 'normal',
                                                                    borderRadius: 5,
                                                                    marginBottom: 2
                                                                }}
                                                            >
                                                                {course.name}
                                                            </Option>
                                                        );
                                                    })}
                                                </Select>
                                            </div>
                                            <div style={{ borderBottom: '1px solid #d7d7d7', marginLeft: 18, width: '92%', }}></div>
                                            <div className="selected-courses">
                                                {selectedCourses.map((course) => (
                                                    <div key={course.id} className="course-tag">
                                                        {course.name}
                                                        <span
                                                            className="remove-icon"
                                                            onClick={() => handleRemoveCourses(course.id)}
                                                        >
                                                            <img style={{ width: 12, height: 12, marginTop: -6 }} src={Xmark} />
                                                        </span>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        :
                                        target == 'Student' && studentsType == 'batch'
                                            ?
                                            <div style={{ marginTop: 20 }}>
                                                <div style={{ color: '#aeaeae', fontSize: 14, padding: '0px 20px' }}>Select batch <span style={{ color: '#ff414d' }}>*</span></div>
                                                <div style={{ marginLeft: 8, marginTop: -5 }}>
                                                    <Select
                                                        bordered={null}
                                                        showSearch={true}
                                                        placeholder={
                                                            <span style={{marginLeft:-10, position:'absolute', zIndex:1}}>
                                                                <SearchOutlined style={{ marginRight: 8, color: "#aeaeae" }} />
                                                                Sample: JEE batch 2025 etc.
                                                            </span>
                                                        }

                                                        onChange={(value) => {
                                                            handleChangeBatches(value);
                                                        }}
                                                        style={{ width: '98%' }}
                                                        suffixIcon={<img src={downArrow} alt="custom icon" style={{ width: 16, height: 16 }} />}
                                                        value={null}
                                                        filterOption={(input, option) => {
                                                            // Case-insensitive search
                                                            return option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                                        }}
                                                        // Optional: customize the no-match message
                                                        notFoundContent="No matching batch found"
                                                    >
                                                        {updatedClassList.map((course) => {
                                                            const isSelected = selectedBatches.some(selected => selected.id === course.id);
                                                            return (
                                                                <Option
                                                                    key={course.id}
                                                                    value={course.id}
                                                                    style={{
                                                                        backgroundColor: isSelected ? '#dacff2' : 'transparent',
                                                                        fontWeight: isSelected ? '500' : 'normal',
                                                                        borderRadius: 5,
                                                                        marginBottom: 2
                                                                    }}
                                                                >
                                                                    {course.name}
                                                                </Option>
                                                            );
                                                        })}
                                                    </Select>
                                                </div>
                                                <div style={{ borderBottom: '1px solid #d7d7d7', marginLeft: 18, width: '92%', }}></div>
                                                <div className="selected-courses">
                                                    {selectedBatches.map((course) => (
                                                        <div key={course.id} className="course-tag">
                                                            {course.name}
                                                            <span
                                                                className="remove-icon"
                                                                onClick={() => handleRemoveBatches(course.id)}
                                                            >
                                                                <img style={{ width: 12, height: 12, marginTop: -6 }} src={Xmark} />
                                                            </span>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                            :
                                            <></>
                    }
                    <div>
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 20, marginLeft: 20 }}>
                            <Checkbox style={{ padding: '5px' }} checked={check} onChange={(e) => { onChangeCheckBox(e) }}>Schedule for Later </Checkbox>
                        </div>
                        {check ?
                            <div className='m-t-5' style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: 25, gap: 70 }}>
                                <div style={{ width: '40%', display: 'flex', flexDirection: 'column' }}>
                                    <AnimatedDatePicker
                                        inputReadOnly={true}
                                        inputId={`${1001}`}
                                        label="Schedule date"
                                        // isMandatory={true}
                                        value={date ? momentDate == '' ? date : moment(date, 'YYYY-MM-DD') : ''}
                                        handleDateChange={handleDate}
                                        // allowClear={true}
                                        disabledDate={disabledDate}
                                    />

                                </div>
                                <div style={{ width: '40%', display: 'flex', flexDirection: 'column' }}>

                                    <AnimatedTimePicker
                                        inputReadOnly={true}
                                        inputId={`start-time-${10001}`}
                                        label="Start time"
                                        // isMandatory={true}
                                        value={time ? moment(time, 'HH:mm') : ''}
                                        handleTimeChange={handleTime}
                                        allowClear={false}
                                        format="hh:mm A"
                                        disabledHours={disabledStartTimeHours}
                                        disabledMinutes={disabledStartTimeMinutes}
                                        disabled={!date}
                                    />

                                </div>
                            </div>
                            : null}
                    </div>
                </div>
                <div style={{ width: '100%', marginTop:20, paddingLeft:10, display:'flex', justifyContent:'space-between'}}>
                    {
                        edit === 'schedule' ?
                                <div style={{ width:'100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Button loading={draftButtonLoader} type='cancel' style={{ width: '45%', borderRadius: '5px', marginRight: '10px', textAlign: 'center', fontWeight: 'bold' }} onClick={() => handleButton('DRAFT', file)} disabled={(fileVisible && fileVisible != 'new file and old file') || ((title && title.trim() != '' && description != '' && descriptionLength <= 250 && !isDisabled) || ((title && title.trim() != '') && description != '' && target  && descriptionLength <= 250 && !isDisabled)) && (editData?.typeAnnouncement == 'text') ? (draftButtonLoader || deleteButtonLoader) ? true : false : true}>SAVE AS DRAFT</Button>
                                    {check !== true ?
                                        <Button loading={announceButtonLoader} type='primary' style={{ width: '50%', borderRadius: '5px', textAlign: 'center', fontWeight: 'bold' }} onClick={() => handleButton('ANNOUNCENOW')} disabled={(fileVisible && fileVisible != 'new file and old file') || ((title && title.trim() != '' && description != '' && descriptionLength <= 250 && !isDisabled) || ((title && title.trim() != '') && description != '' && target  && descriptionLength <= 250 && !isDisabled)) && (editData?.typeAnnouncement == 'text') ? (announceButtonLoader || deleteButtonLoader) ? true : false : true}>ANNOUNCE NOW</Button>
                                        :
                                        <Button loading={scheduleLoader} type='primary' style={{ width: '180px', marginLeft: "8px", borderRadius: '5px', textAlign: 'center', fontWeight: 'bold' }} onClick={() => handleButton('SCHEDULE')}
                                        // disabled={(fileVisible && fileVisible != 'new file and old file') || ((  title && title.trim() != '' && date != '' && time != '') && description != '' && descriptionLength <= 250) || ((title && title.trim() != '') && description != '' && target && descriptionLength <= 250 && date != '' && time != '') ? scheduleLoader ? true : false : true}

                                        disabled={(fileVisible && fileVisible != 'new file and old file') ||(date != '' && time != '' && !isDisabled) ||(( title && title.trim() != '' && description != '' && descriptionLength <= 250 && date != '' && time != '' && !isDisabled) || ((title && title.trim() != '') && description != '' && target  && descriptionLength <= 250 && !isDisabled)) && (editData?.typeAnnouncement == 'text')  ? (scheduleLoader || deleteButtonLoader) ? true : false : true}
                                        // disabled={date == '' ? false : true}
                                        >SCHEDULE</Button>
                                    }
                                </div>

                            :

                                <div style={{ width:'100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    
                                    <Button loading={draftButtonLoader} type='cancel' style={{ width: '45%', borderRadius: '5px', marginRight: '10px', textAlign: 'center', fontWeight: 'bold' }} onClick={() => handleButton('DRAFT', file)} disabled={(fileVisible && fileVisible != 'new file and old file' && (!check || (date && time)) && (title && title.trim() !== '')) || ((title && title.trim() != '' && description != '' && descriptionLength <= 250 && !isDisabled) || ((title && title.trim() != '') && description != '' && target && descriptionLength <= 250 && !isDisabled)) && (editData?.typeAnnouncement == 'text') ? (draftButtonLoader || deleteButtonLoader) ? true : false : true}>SAVE AS DRAFT</Button>
                                    {check !== true ?
                                        <Button loading={announceButtonLoader} type='primary' style={{ width: '50%', borderRadius: '5px', textAlign: 'center', fontWeight: 'bold' }} onClick={() => handleButton('ANNOUNCENOW')} disabled={(fileVisible && fileVisible != 'new file and old file' && (!check || (date && time)) && (title && title.trim() !== '')) || ((title && title.trim() != '' && description != '' && descriptionLength <= 250 && !isDisabled) || ((title && title.trim() != '') && description != '' && target  && descriptionLength <= 250 && !isDisabled)) && (editData?.typeAnnouncement == 'text') ? (announceButtonLoader || deleteButtonLoader) ? true : false : true}>ANNOUNCE NOW</Button>
                                        :
                                        <Button loading={scheduleLoader} type='primary' style={{ width: '180px', marginLeft: "8px", borderRadius: '5px', textAlign: 'center', fontWeight: 'bold' }} onClick={() => handleButton('SCHEDULE')}
                                            // disabled={((title && title.trim() != '' && date != '' && time != '') && description != '' && descriptionLength <= 250) || ((title && title.trim() != '') && description != '' && target && descriptionLength <= 250 && date != '' && time != '' && !isDisabled) ? scheduleLoader ? true : false : true}

                                        disabled={(fileVisible && fileVisible != 'new file and old file' && (!check || (date && time)) && (title && title.trim() !== ''))  ||
                                            (
                                                title && title.trim() !== '' &&
                                                description !== '' &&
                                                descriptionLength <= 250 &&
                                                !isDisabled &&
                                                (!check || (date && time)) // If `check` is false, skip date/time validation
                                              ) 
                                             && (editData?.typeAnnouncement == 'text')  ? (scheduleLoader || deleteButtonLoader) ? true : false : true}
                                        // disabled={date == '' ? false : true}
                                        >SCHEDULE</Button>
                                    }
                                </div>


                    }
                </div>


            </Drawer>
        </div>
    )
}


const mapStateToProps = (state) => {
    const {
        standardList,
        sortFilter,
        searchFilter, announcement,

    } = state.announcement;

    const { courseCategoryData, courseSubCategoriesData, autocompleteSearchData,courseDashboardData } = state.courseManagement
    const { classList } = state.schedule
    return {
        standardList,
        sortFilter, courseCategoryData, courseSubCategoriesData, autocompleteSearchData, classList,courseDashboardData,
        searchFilter, announcement,
    };
};

const mapDispatchToProps = (dispatch) => ({
    postAnnouncemnt: (object, callback, successCallback) => dispatch(postAnnouncemnt(object, callback, successCallback)),
    fetchAnnouncement: (search, sort, key, callback) => dispatch(fetchAnnouncement(search, sort, key, callback)),
    deleteAnnouncement: (id, callback, successCallback) => dispatch(deleteAnnouncement(id, callback, successCallback)),
    fetchNotification: () => dispatch(fetchNotification()),
    notificationBadgeList: () => dispatch(notificationBadgeList()),
    setAnnounceKey: (val) => dispatch(setAnnounceKey(val)),
    getCoursesCategoriesForNotifications: () => dispatch(getCoursesCategoriesForNotifications()),
    getCoursesSubCategoriesForNotification: () => dispatch(getCoursesSubCategoriesForNotification()),
    getAutocompleteSearchForNotification: (search, callBack) => dispatch(getAutocompleteSearchForNotification(search, callBack)),
    fetchClassList: (search, subId, callback) => dispatch(fetchClassList(search, subId, callback)),
    getCourseDashboardData: (callBack) => dispatch(getCourseDashboardData(callBack)),


});

export default connect(
    mapStateToProps,
    mapDispatchToProps

)(CloneAnnouncement);